import React from 'react'
import PageHelmet from "../component/common/Helmet";
import { FiChevronUp , FiCheck } from "react-icons/fi";
import ScrollToTop from 'react-scroll-up';
import { Link } from 'react-router-dom';
const pricing = () => {
    return (
<>
<PageHelmet pageTitle='Portfolio' />
 {/* Start Page Wrapper  */}
 <main className="page-wrapper">
 {/* Start Pricing Tbale Area  */}
 <div className="design" id="design">
 <div className="rn-pricing-table-area ptb--120 ">
     <div className="container">
         <div className="row">

             {/* Start PRicing Table Area  */}
             <div className="col-lg-4 col-md-6 col-12 mt--30">
                 <div className="rn-pricing">
                     <div className="pricing-table-inner">
                         <div className="pricing-header">
                             <h4 className="title">BASIC WEBSITE PACKAGE</h4>
                             <div className="pricing">
                                 <span className="price">$245</span>
                                 <span className="subtitle">USD Per Month</span>
                             </div>
                         </div>
                         <div className="pricing-body">
                             <ul className="list-style--1">
                                 <li><FiCheck /> 2 Stock Images</li>
                                 <li><FiCheck /> 3 Page Website</li>
                                 <li><FiCheck /> 1 jQuery Slider Banner</li>
                                 <li><FiCheck /> Contact/Query Form</li>
                                 <li><FiCheck /> Complete W3C Certified HTML</li>
                                 <li><FiCheck /> 48 to 72 hours TAT</li>
                                 <li><FiCheck /> 100% Satisfaction Guarantee</li>
                                 <li><FiCheck /> 100% Unique Design Guarantee</li>
                                 <li><FiCheck /> 100% Money Back Guarantee *</li>
                             </ul>
                         </div>
                         <div className="pricing-footer">
                             <a className="rn-btn" href="#pricing">Purchase Now</a>
                         </div>
                     </div>
                 </div>
             </div>
             {/* End PRicing Table Area  */}

             {/* Start PRicing Table Area  */}
             <div className="col-lg-4 col-md-6 col-12 mt--30">
                 <div className="rn-pricing active">
                     <div className="pricing-table-inner">
                         <div className="pricing-header">
                             <h4 className="title">START UP WEBSITE PACKAGE</h4>
                             <div className="pricing">
                                 <span className="price">$395</span>
                                 <span className="subtitle">USD Per Month</span>
                             </div>
                         </div>
                         <div className="pricing-body">
                             <ul className="list-style--1">
                             <li><FiCheck /> 2 Stock Images</li>
                                 <li><FiCheck /> 3 Page Website</li>
                                 <li><FiCheck /> 1 jQuery Slider Banner</li>
                                 <li><FiCheck /> Contact/Query Form</li>
                                 <li><FiCheck /> Complete W3C Certified HTML</li>
                                 <li><FiCheck /> 48 to 72 hours TAT</li>
                                 <li><FiCheck /> 100% Satisfaction Guarantee</li>
                                 <li><FiCheck /> 100% Unique Design Guarantee</li>
                                 <li><FiCheck /> 100% Money Back Guarantee *</li>
                             </ul>
                         </div>
                         <div className="pricing-footer">
                             <a className="rn-btn" href="#pricing">Purchase Now</a>
                         </div>
                     </div>
                 </div>
             </div>
             {/* End PRicing Table Area  */}

             {/* Start PRicing Table Area  */}
             <div className="col-lg-4 col-md-6 col-12 mt--30">
                 <div className="rn-pricing">
                     <div className="pricing-table-inner">
                         <div className="pricing-header">
                             <h4 className="title">PROFESSIONAL WEBSITE PACKAGE</h4>
                             <div className="pricing">
                                 <span className="price">$799</span>
                                 <span className="subtitle">USD Per Month</span>
                             </div>
                         </div>
                         <div className="pricing-body">
                             <ul className="list-style--1">
                             <li><FiCheck /> 2 Stock Images</li>
                                 <li><FiCheck /> 3 Page Website</li>
                                 <li><FiCheck /> 1 jQuery Slider Banner</li>
                                 <li><FiCheck /> Contact/Query Form</li>
                                 <li><FiCheck /> Complete W3C Certified HTML</li>
                                 <li><FiCheck /> 48 to 72 hours TAT</li>
                                 <li><FiCheck /> 100% Satisfaction Guarantee</li>
                                 <li><FiCheck /> 100% Unique Design Guarantee</li>
                                 <li><FiCheck /> 100% Money Back Guarantee *</li>
                             </ul>
                         </div>
                         <div className="pricing-footer">
                             <a className="rn-btn" href="#pricing">Purchase Now</a>
                         </div>
                     </div>
                 </div>
             </div>
             {/* End PRicing Table Area  */}
             
         </div>
         <div className="row justify-content-md-center">
             {/* Start PRicing Table Area  */}
             
             <div className="col-lg-4 col-md-6 col-12 mt--30" >
                <div className="padd">
                 <div className="rn-pricing active">
                     <div className="pricing-table-inner">
                         <div className="pricing-header">
                             <h4 className="title">START UP WEBSITE PACKAGE</h4>
                             <div className="pricing">
                                 <span className="price">$395</span>
                                 <span className="subtitle">USD Per Month</span>
                             </div>
                         </div>
                         <div className="pricing-body">
                             <ul className="list-style--1">
                             <li><FiCheck /> 2 Stock Images</li>
                                 <li><FiCheck /> 3 Page Website</li>
                                 <li><FiCheck /> 1 jQuery Slider Banner</li>
                                 <li><FiCheck /> Contact/Query Form</li>
                                 <li><FiCheck /> Complete W3C Certified HTML</li>
                                 <li><FiCheck /> 48 to 72 hours TAT</li>
                                 <li><FiCheck /> 100% Satisfaction Guarantee</li>
                                 <li><FiCheck /> 100% Unique Design Guarantee</li>
                                 <li><FiCheck /> 100% Money Back Guarantee *</li>
                             </ul>
                         </div>
                         <div className="pricing-footer">
                             <a className="rn-btn" href="#pricing">Purchase Now</a>
                         </div>
                     </div>
                 </div>
             </div>
             </div>
             {/* End PRicing Table Area  */}

             {/* Start PRicing Table Area  */}
             
             <div className="col-lg-4 col-md-6 col-12 mt--30">
                <div className="padd">
                 <div className="rn-pricing">
                     <div className="pricing-table-inner">
                         <div className="pricing-header">
                             <h4 className="title">PROFESSIONAL WEBSITE PACKAGE</h4>
                             <div className="pricing">
                                 <span className="price">$799</span>
                                 <span className="subtitle">USD Per Month</span>
                             </div>
                         </div>
                         <div className="pricing-body">
                             <ul className="list-style--1">
                             <li><FiCheck /> 2 Stock Images</li>
                                 <li><FiCheck /> 3 Page Website</li>
                                 <li><FiCheck /> 1 jQuery Slider Banner</li>
                                 <li><FiCheck /> Contact/Query Form</li>
                                 <li><FiCheck /> Complete W3C Certified HTML</li>
                                 <li><FiCheck /> 48 to 72 hours TAT</li>
                                 <li><FiCheck /> 100% Satisfaction Guarantee</li>
                                 <li><FiCheck /> 100% Unique Design Guarantee</li>
                                 <li><FiCheck /> 100% Money Back Guarantee *</li>
                             </ul>
                         </div>
                         <div className="pricing-footer">
                             <a className="rn-btn" href="#pricing">Purchase Now</a>
                         </div>
                     </div>
                 </div>
             </div>
             {/* End PRicing Table Area  */}
             </div>
         </div>
     </div>
 </div>
 </div>
 
 {/* End Pricing Tbale Area  */}
</main>
{/* End Page Wrapper  */}
</>
)}
export default pricing;